import { autoinject, bindingMode, customAttribute } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { watch } from 'aurelia-watch-decorator';
import { SortController, SortInstruction } from 'framework/aurelia_tools/sort-controller';

@autoinject
@customAttribute('af-sort-context')
export class SortContextCustomAttribute {
  @bindable(({ defaultBindingMode: bindingMode.twoWay, primaryProperty: true })) instruction: SortInstruction = null;

  constructor(private sortController: SortController) { }

  instructionChanged(instruction: SortInstruction) {
    this.sortController.instruction = instruction;
  }

  @watch((x: SortContextCustomAttribute) => x.sortController.instruction)
  private controllerInstructionChanged(instruction: SortInstruction) {
    this.instruction = instruction;
  }
}
